import { lighten } from "@theme-ui/color";
import { Theme } from "theme-ui";

export const badges: Theme["badges"] = {
  primary: {
    color: "text.dark",
    bg: lighten("text.brand", 0.35),
    height: "24px",
    justifyContent: "center",
    alignItems: "center",
    display: "inline-flex",
    flexGrow: 0,
    padding: "0 12px",
    borderRadius: "28px"
  },
  highlight: {
    variant: "badges.primary",
    color: "text.highlight",
    bg: lighten("text.highlight", 0.32)
  }
};
